// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart[data-v-b8fc6ce8]{display:flex;flex-direction:column;justify-content:center;align-items:center}.chart[data-v-b8fc6ce8],.myChart[data-v-b8fc6ce8]{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
